import React from "react";
import "../organisationCard.css";
import { Organisation } from "../../../features/organisation/organisationTypes";
import { ColumnFlexBox, RowFlexBox } from "../../common/FlexBoxes";
import { Icon, ParagraphSmall } from "@tal-gel/components-v2";
import { useTheme } from "@emotion/react";

interface propsFromComponent {
  item: Organisation;
}

type Props = propsFromComponent;

const OrganisationModalAdditionalInfo: React.FC<Props> = ({ item }) => {
  const theme = useTheme();

  return (
    <ColumnFlexBox>
      <RowFlexBox
        style={{
          display: item.locationLabel ? "flex" : "none",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Icon name="LocationPin" fill={theme.tokens.global.themeColorIconDefault} width="18" style={{ paddingTop: 1 }} />
        <ParagraphSmall>
          <span className={"black"}>{item.locationLabel}</span>
        </ParagraphSmall>
      </RowFlexBox>
      <RowFlexBox
        style={{
          display: item.costLabel ? "flex" : "none",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Icon name="CurrencyDollarCircle" fill={theme.tokens.global.themeColorIconDefault} width="18" style={{ paddingTop: 1 }} />
        <ParagraphSmall>
          <span className={"black"}>{item.costLabel}</span>
        </ParagraphSmall>
      </RowFlexBox>
    </ColumnFlexBox>
  );
};

export default OrganisationModalAdditionalInfo;
